module.exports = __webpack_public_path__ + "static/media/jenkins.72505cf7.png";